/**
 * 🔒 How many rows a tile whose items are a list draws before it offers the
 * rest (piece 4's Tile; piece 15's Regional section; decision 5960). One
 * Organization setting, `display.tileListRows`, a whole number from 1 to 50,
 * and four where no row is held. The product owner, 2026-10-19: *"make all the
 * tiles that have lists cap at x items. Default them at 5 and we can adjust the
 * tile stack somewhere"*, then *"4"*.
 *
 * 🔨 The shell reads it once with the viewer's zone and date format (decision
 * 0261), and the Tile reads it from there; no tile fetches it.
 */
export const TILE_LIST_ROWS_KEY = 'display.tileListRows';
export const DEFAULT_TILE_LIST_ROWS = 4;
export const MIN_TILE_LIST_ROWS = 1;
export const MAX_TILE_LIST_ROWS = 50;

/** A numeric string such as "6" is not a row count: the API refuses it and nothing here coerces it. */
function isRowCount(value: unknown): value is number {
  return typeof value === 'number' && Number.isInteger(value) && value >= MIN_TILE_LIST_ROWS && value <= MAX_TILE_LIST_ROWS;
}

/** The held value as a row count; anything absent or out of range reads as the default of four. */
export function asTileListRows(held: unknown): number {
  return isRowCount(held) ? held : DEFAULT_TILE_LIST_ROWS;
}

/** The refusal a typed row count earns, or null; a blank clears the row back to the default of four. */
export function tileListRowsProblem(value: unknown): string | null {
  if (value === null || value === undefined || value === '') return null;
  return isRowCount(value) ? null : `the rows a tile list shows is a whole number from ${MIN_TILE_LIST_ROWS} to ${MAX_TILE_LIST_ROWS}`;
}
